import { render } from "./DownloadPage.vue?vue&type=template&id=6d4829ea&scoped=true"
import script from "./DownloadPage.vue?vue&type=script&lang=js"
export * from "./DownloadPage.vue?vue&type=script&lang=js"

import "./DownloadPage.vue?vue&type=style&index=0&id=6d4829ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4829ea"]])

export default __exports__